module.exports = __webpack_public_path__ + "static/media/vercel.9e6b006c.svg";